import React from 'react'

export default ({ name, link, image }) => (
  <div className="banner">
    <a href={link} target="_blank" rel="noopener">
      <img lazyload="true" src={image.sourceUrl} alt={name} />
    </a>
  </div>
)
